import React from "react";
import styled from "styled-components";

const PageWrapper = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Events = () => {
  return (
    <PageWrapper>
      <h1>Events</h1>
      <p>Page coming soon...</p>
    </PageWrapper>
  );
};

export default Events;
